<section class="rc" aria-labelledby="rc-title">
  <header class="rc__head">
    <h2 class="bk-section-title" id="rc-title">Recipients</h2>
    @if (loaded) {
      <p class="rc__lead">{{ lead }}</p>
      <p class="rc__sub">
        Open a group to see its members, or to leave someone out of this campaign.
      </p>
    } @else {
      <span class="bk-skel" style="width: min(360px, 80%); height: 16px" aria-hidden="true"></span>
    }
  </header>

  <div class="bk-panel rc__panel">
    @if (!loaded) {
      <div class="rc__skel" role="status">
        <span class="bk-sr-only">Loading recipient groups</span>
        @for (row of [1, 2, 3]; track row) {
          <span class="bk-skel" style="height: 14px" aria-hidden="true"></span>
        }
      </div>
    } @else if (groups.length) {
      <table class="bk-log">
        <thead>
          <tr>
            <th scope="col">Group</th>
            <th scope="col" class="col-kind">Type</th>
            <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
          </tr>
        </thead>
        <tbody>
          @for (group of groups; track group.kind + group.uuid + $index) {
            <!-- The whole row opens the group for pointers; keyboards use its one button. -->
            <tr class="is-link" (click)="openMembers(group)">
              <td class="col-name">
                <span class="rc__name">{{ group.name || "Unnamed group" }}</span>
                <span class="rc__kind-inline">{{ kindLabel[group.kind] }}</span>
              </td>
              <td class="quiet col-kind">{{ kindLabel[group.kind] }}</td>
              <td class="col-actions">
                <span class="bk-row-actions">
                  <button
                    type="button"
                    class="bk-icon-btn"
                    [attr.aria-label]="'View members of ' + (group.name || 'this group')"
                    matTooltip="View members"
                    (click)="$event.stopPropagation(); openMembers(group)"
                  >
                    <span class="bk-sym" aria-hidden="true">group</span>
                  </button>
                  <span class="bk-sym rc__go" aria-hidden="true">chevron_right</span>
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="rc__empty">
        <p class="rc__empty-title">No recipient groups.</p>
        <p class="rc__empty-body">
          This campaign has no organizations, tags or segments, so its sends reach no one.
        </p>
      </div>
    }
  </div>

  <!-- member list -->
  @if (showMembersList && selected) {
    <app-group-members-list
      (onClose)="showMembersList = false"
      [openModal]="showMembersList"
      [groupName]="selected.kind"
      [groupId]="selected.uuid"
      [title]="selected.name"
    ></app-group-members-list>
  }
</section>
